import React, { useState, useContext } from "react";
import { Modal, ModalButtonID, Select } from '../../ui/components';
import classNames from "classnames";
import { useSubscribe } from '../../hooks';
import { command$ } from '../../observables/command';
import { CommandID } from '../../commands';
import { AppSettingsContext } from '../../context/config';
import { createURI } from '../../shared/utils/URI';
import { mergeRight, omit } from 'ramda';
import { LocalFileSystemID } from '../../shared/types';
import info from '../../../../package.json';
import styles from './Settings.less';
export const themes = ['black', 'blue', 'green', 'pink'];
const fileIconThemes = [
    { value: '', label: 'None' },
    { value: 'seti', label: 'Seti (Visual Studio Code)' },
    { value: 'material', label: 'Material Icon Theme' },
    { value: 'vsicons', label: 'VSCode Icons' },
    { value: 'ayu', label: 'Ayu' },
    { value: 'vscodegreat', label: 'VSCode Great Icons' },
    { value: 'fileicons', label: 'File Icons' },
    { value: 'nomo', label: 'Nomo Dark' }
];
const buttons = [
    {
        id: ModalButtonID.Cancel,
        label: 'Cancel'
    },
    {
        id: ModalButtonID.Ok,
        label: 'Save'
    }
];
export default function Settings() {
    const appSettings = useContext(AppSettingsContext);
    const [shown, show] = useState(false);
    const [mode, setMode] = useState(appSettings.mode);
    const [theme, setTheme] = useState(appSettings.theme);
    const [fileTheme, setFileTheme] = useState(appSettings.fileTheme ?? '');
    const [timeFmt, setTimeFmt] = useState(appSettings.timeFmt);
    const [sizeFmt, setSizeFmt] = useState(appSettings.sizeFmt);
    useSubscribe(() => command$.subscribe(cmd => {
        switch (cmd.id) {
            case CommandID.Settings: {
                show(true);
                break;
            }
        }
    }));
    const onClose = (id) => {
        show(false);
        if (id == ModalButtonID.Ok) {
            const settings = omit(['fileIcons'], appSettings);
            window.f5.write(createURI(LocalFileSystemID, settings.settings), JSON.stringify(mergeRight(settings, { mode, theme, fileTheme, timeFmt, sizeFmt })));
        }
    };
    return shown && React.createElement(Modal, { buttons: buttons, onClose: onClose, options: { x: true } },
        React.createElement("div", { className: styles.root + ' modal-content' },
            React.createElement("header", null, "Settings"),
            React.createElement("form", { className: styles.form, onSubmit: e => e.preventDefault() },
                React.createElement("label", null, "Mode:"),
                React.createElement("div", { className: "dry-buttons" },
                    React.createElement("button", { onClick: () => setMode('light'), "data-checked": mode == 'light' }, "Light"),
                    React.createElement("button", { onClick: () => setMode('system'), "data-checked": mode == 'system' }, "System"),
                    React.createElement("button", { onClick: () => setMode('dark'), "data-checked": mode == 'dark' }, "Dark")),
                React.createElement("label", null, "Default Color Theme:"),
                React.createElement("div", { className: styles.themes }, themes.map(t => React.createElement("span", { key: t, "data-mode": "dark", "data-theme": t, "data-active": t == theme, onClick: () => setTheme(t) }))),
                React.createElement("label", null, "File Icon Theme:"),
                React.createElement(Select, { value: fileTheme, options: fileIconThemes, onChange: setFileTheme }),
                React.createElement("label", null, "Date/time format:"),
                React.createElement("input", { className: classNames('dry'), name: "date-time-fmt", value: timeFmt, onChange: e => setTimeFmt(e.target.value), placeholder: "e.g. yyyy-MM-dd HH:mm" }),
                React.createElement("p", null,
                    React.createElement("i", { className: "icon" }, "info"),
                    React.createElement("a", { href: "https://date-fns.org/v3.6.0/docs/format", target: "_blank" }, "Supported formats")),
                React.createElement("label", null, "Filesize format:"),
                React.createElement("input", { className: classNames('dry'), name: "filesize-fmt", value: sizeFmt, onChange: e => setSizeFmt(e.target.value), placeholder: "e.g. 0.0 b" }),
                React.createElement("p", null,
                    React.createElement("i", { className: "icon" }, "info"),
                    React.createElement("a", { href: "http://numeraljs.com/#format-bytes", target: "_blank" }, "Supported formats"))),
            React.createElement("small", null,
                "Version: ",
                info.version)));
}
